import {ContentCast} from './content-cast.model';
import {Metadata} from './metadata.model';

export class MetadataCastTypeMap {
  constructor(
    public castType?: string,
    public castId?: number,
    public metadataId?: number,
    public cast?: ContentCast,
    public metadata?: Metadata,
  ) {}
}
